import axios from 'axios';
import { message } from 'antd';
import Cookies from 'js-cookie';
import { API_BASE_PATH, COOKIE_TOKEN } from '@/scripts/config';
import { PATH_LOGIN } from '@/router/path';
import { getPath } from '@/scripts/utils';

const ajax = axios.create({
    // 在这里配置全局的 Axios 选项
    baseURL: process.env.NODE_ENV === 'development' ? API_BASE_PATH : window.apiDomain,
});

// 设置请求拦截器
ajax.interceptors.request.use(
    function (config) {
        // 避免初始化时没有cookie
        const token = Cookies.get(COOKIE_TOKEN);
        if (Cookies.get(COOKIE_TOKEN)) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // 在发送请求之前做些什么
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    },
);
// 设置响应拦截器
ajax.interceptors.response.use(
    function (response) {
        // 对响应数据做些什么
        const { status, data, config } = response;
        if (status === 200 && data) {
            if (data.bool_status) {
                if (config.rawResponse) return data;
                return data.data;
            } else {
                message.error({ key: 'ajaxError', content: data?.msg ? data.msg : '请求出现错误', duration: 1.5 });
            }
        } else {
            message.error({ key: 'ajaxError', content: data?.msg ? data.msg : '请求出现错误', duration: 1.5 });
        }
        return null;
    },
    async function (error) {
        const originalRequest = error.config;
        // 只处理401，且未重试过
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken) {
                try {
                    // 注意：这里用axios（不是ajax）防止递归拦截
                    const res = await axios.post(
                        '/admin/token',
                        '',
                        {
                            baseURL: process.env.NODE_ENV === 'development' ? API_BASE_PATH : window.apiDomain,
                            headers: {
                                Authorization: `Bearer ${refreshToken}`,
                            },
                        },
                    );
                    // 兼容多种返回格式
                    let newToken = null;
                    if (res.data) {
                        if (res.data.access_token) {
                            newToken = res.data.access_token;
                        } else if (res.data.data && res.data.data.access_token) {
                            newToken = res.data.data.access_token;
                        }
                    }
                    if (newToken) {
                        Cookies.set(COOKIE_TOKEN, newToken, { expires: 7 });
                        // localStorage.setItem('refresh_token', newToken);
                        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                        return ajax(originalRequest);
                    } else {
                        // 没有新token，跳转登录
                        Cookies.remove(COOKIE_TOKEN);
                        localStorage.removeItem('refresh_token');
                        window.location.href = '/login';
                        return Promise.reject(error);
                    }
                } catch (e) {
                    // 刷新失败，跳转登录
                    Cookies.remove(COOKIE_TOKEN);
                    localStorage.removeItem('refresh_token');
                    window.location.href = '/login';
                    return Promise.reject(error);
                }
            } else {
                // 没有refresh_token，跳转登录
                window.location.href = '/login';
                return Promise.reject(error);
            }
        }
        error.response?.data?.msg ? message.error(error.response.data.msg) : message.error('请求出现错误');
        return Promise.reject(error);
    },
);

export default ajax;
